import * as React from 'react';
import PropTypes from 'prop-types';

import { Typography, withStyles } from '@material-ui/core';
import { updateAllOthersAreHiddenProperties } from '../../elementStateUtils';
import TaskElement from './TaskElement';
import FormValidation from './FormValidation';

const styles = theme => ({
    validationText: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
        width: '100%',
        outline: 'none',
    },
});

class TaskContent extends React.Component {
    state = {
        showValidationErrors: false,
    }

    validationRef = React.createRef()

    validate = () => {
        this.setState({ showValidationErrors: true });
        return this.validationRef.current.validate();
    }

    validateAndSave = (callback) => {
        if (this.validate()) {
            this.props.onSaveChanges(callback);
        }
    }

    saveWithoutValidation = (callback) => {
        this.props.onSaveChanges(callback);
    }

    render() {
        const {
            className, classes, task, taskResponses, noContent, TaskFormProps, LinkElementProps, showTitle, getProgramItem, getSpecificTaskResponses, translations, onResponse, TaskElementProps,
        } = this.props;

        if (!task) {
            return null;
        }

        const taskElements = task.contentElements || [];
        updateAllOthersAreHiddenProperties(task, getSpecificTaskResponses, getProgramItem);

        return (
            <div className={className}>
                {showTitle && (
                    <Typography variant="h4" className={classes.title}>
                        {task.name}
                    </Typography>
                )}

                {taskElements.length === 0
                    ? noContent
                    : taskElements.map((item, index) => (
                        <TaskElement
                            key={`${task.elementId}-${task.id}-${item.id}`}
                            task={task}
                            getProgramItem={getProgramItem}
                            getSpecificTaskResponses={getSpecificTaskResponses}
                            element={item}
                            taskResponses={taskResponses}
                            TaskFormProps={TaskFormProps}
                            LinkElementProps={LinkElementProps}
                            elementIndex={index}
                            translations={translations}
                            onResponse={onResponse}
                            showValidationErrors={this.state.showValidationErrors}
                            {...TaskElementProps}
                        />
                    ))}

                <FormValidation
                    ref={this.validationRef}
                    task={task}
                    responses={taskResponses}
                    translations={translations}
                    showValidations={this.state.showValidationErrors}
                    getProgramItem={getProgramItem}
                    getSpecificTaskResponses={getSpecificTaskResponses}
                />
            </div>
        );
    }
}

TaskContent.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    task: PropTypes.object,
    TaskFormProps: PropTypes.object,
    LinkElementProps: PropTypes.object,
    noContent: PropTypes.node,
    taskResponses: PropTypes.object,
    showTitle: PropTypes.bool,
    elementPreContent: PropTypes.func,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
    translations: PropTypes.object,
    onResponse: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired,
    TaskElementProps: PropTypes.object,
};

TaskContent.defaultProps = {
    className: null,
    noContent: null,
    taskResponses: null,
    TaskFormProps: null,
    LinkElementProps: null,
    showTitle: false,
    elementPreContent: null,
    task: null,
    translations: null,
    TaskElementProps: null,
};

export default withStyles(styles)(TaskContent);
